import _slicedToArray from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _styled from "styled-components";
import React, { useState, useMemo } from "react";
import { ReactComponent as BackIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/back.svg";
import InfoIconAsset from "@smartheat/common/png/streamline-icon-messages-bubble-information@24x24.png";
import { formatDecimalNumber } from "../../../controls/utils";
import { NumberInput } from "../../../controls/NumberInput";
import { RegisterControl } from "../../../controls/RegisterControl";

var Container = _styled.div.withConfig({
  displayName: "Section__Container",
  componentId: "sc-1o6js9s-0"
})(["margin-bottom:20px;"]);

var Row = _styled.div.withConfig({
  displayName: "Section__Row",
  componentId: "sc-1o6js9s-1"
})(["display:flex;align-items:center;margin-bottom:20px;padding:0 20px;"]);

var Label = _styled.div.withConfig({
  displayName: "Section__Label",
  componentId: "sc-1o6js9s-2"
})(["flex:1;font-size:20px;@media screen and (max-width:419px){font-size:18px;}"]);

var BriefSettings = _styled.div.withConfig({
  displayName: "Section__BriefSettings",
  componentId: "sc-1o6js9s-3"
})(["display:flex;align-items:center;cursor:pointer;"]);

var BaseValue = _styled.div.withConfig({
  displayName: "Section__BaseValue",
  componentId: "sc-1o6js9s-4"
})(["margin-left:10px;font-size:20px;min-width:60px;text-align:right;@media screen and (max-width:419px){min-width:50px;font-size:18px;}"]);

var Value = _styled(BaseValue).withConfig({
  displayName: "Section__Value",
  componentId: "sc-1o6js9s-5"
})(["border-left:1px solid black;"]);

var SettingValue = _styled(BaseValue).withConfig({
  displayName: "Section__SettingValue",
  componentId: "sc-1o6js9s-6"
})(["&:nth-last-of-type(1){color:blue;}&:nth-last-of-type(2){color:limegreen;}&:nth-last-of-type(3){color:darkorange;}"]);

var Button = _styled.button.withConfig({
  displayName: "Section__Button",
  componentId: "sc-1o6js9s-7"
})(["background:none transparent;border:0 none;padding:0;cursor:pointer;margin-right:8px;&:focus{outline:0 none;}svg{display:block;width:24px;height:24px;transform:rotate(", ");transition:transform 0.3s;@media screen and (max-width:419px){width:20px;height:20px;}}"], function (p) {
  return p.expanded ? "90deg" : "270deg";
});

var Details = _styled.div.withConfig({
  displayName: "Section__Details",
  componentId: "sc-1o6js9s-8"
})(["padding-left:36px;"]);

var Description = _styled.div.withConfig({
  displayName: "Section__Description",
  componentId: "sc-1o6js9s-9"
})(["font-size:20px;display:flex;align-items:center;margin-bottom:20px;padding-right:20px;img{flex:0 0 auto;margin-right:8px;fill:#333;}@media screen and (max-width:419px){font-size:18px;}"]);

var SettingsList = _styled.div.withConfig({
  displayName: "Section__SettingsList",
  componentId: "sc-1o6js9s-10"
})(["& > div:nth-of-type(1){color:blue;}& > div:nth-of-type(2){color:limegreen;}& > div:nth-of-type(3){color:darkorange;}"]);

function formatValue(value) {
  var register = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _register$decimals = register.decimals,
      decimals = _register$decimals === void 0 ? 0 : _register$decimals;
  var hasValue = typeof value === "undefined";
  return hasValue ? "--" : formatDecimalNumber(value, decimals);
}

function renderSettingControl(regConfig, value, setRegister) {
  return /*#__PURE__*/React.createElement(NumberInput, {
    key: regConfig.id,
    value: value,
    title: regConfig.title,
    unit: regConfig.unit,
    incrementable: regConfig.incrementable,
    minValue: regConfig.minValue,
    maxValue: regConfig.maxValue,
    decimals: regConfig.decimals,
    onChange: function onChange(value) {
      return setRegister(regConfig.id, value);
    }
  }, function (_ref) {
    var onClick = _ref.onClick;
    return /*#__PURE__*/React.createElement(SettingValue, {
      onClick: onClick
    }, formatValue(value, regConfig));
  });
}

export function Section(_ref2) {
  var section = _ref2.section,
      registersData = _ref2.registersData,
      registersConfig = _ref2.registersConfig,
      setRegister = _ref2.setRegister;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var sensorConfig = registersConfig[section.register];
  var settings = useMemo(function () {
    return section.settings && sensorConfig ? section.settings.map(function (_ref3) {
      var register = _ref3.register;
      return registersConfig[register];
    }).filter(function (value) {
      return !!value;
    }) : [];
  }, [section, sensorConfig]);

  if (!sensorConfig) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Button, {
    expanded: expanded,
    onClick: function onClick() {
      return setExpanded(function (e) {
        return !e;
      });
    }
  }, /*#__PURE__*/React.createElement(BackIcon, null)), /*#__PURE__*/React.createElement(Label, null, section.title), settings.length > 0 && /*#__PURE__*/React.createElement(BriefSettings, null, settings.length > 2 && renderSettingControl(settings[2], registersData[settings[2].id], setRegister), settings.length > 1 && renderSettingControl(settings[1], registersData[settings[1].id], setRegister), settings.length > 0 && renderSettingControl(settings[0], registersData[settings[0].id], setRegister)), /*#__PURE__*/React.createElement(Value, null, formatValue(registersData[sensorConfig.id], sensorConfig))), expanded && /*#__PURE__*/React.createElement(Details, null, /*#__PURE__*/React.createElement(Description, null, /*#__PURE__*/React.createElement("img", {
    src: InfoIconAsset,
    alt: ""
  }), /*#__PURE__*/React.createElement("div", null, sensorConfig.title)), /*#__PURE__*/React.createElement(SettingsList, null, settings.map(function (regConfig) {
    return /*#__PURE__*/React.createElement(RegisterControl, {
      key: regConfig.id,
      value: registersData[regConfig.id],
      regConfig: regConfig,
      setRegister: setRegister
    });
  }))));
}